export {default as chord} from "./src/chord";
export {default as ribbon} from "./src/ribbon";



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-chord/index.js
// module id = ../../../../d3-chord/index.js
// module chunks = vendor